import { ThisConnector } from '../../../../api/connector'
import { BaseApiResponse } from '../../../../api/shared'

export function updateUserNotificationPreference(this: ThisConnector) {
  return this.connector.put<BaseApiResponse>(
    'users/preferences/newuser/notification'
  )
}
